import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { AUTH_CLIENTID } from '@/config';
import { getMsalInstance } from './msal-instance';

export default class AuthService {
  private get msal() {
    return getMsalInstance()!;
  }

  getUser() {
    return this.msal.getAllAccounts()[0] ?? null;
  }

  async login() {
    const API_SCOPE = `api://${AUTH_CLIENTID}/access_as_user`;
    await this.msal.loginRedirect({ scopes: [API_SCOPE] });
  }

  async acquireToken(): Promise<string> {
    const account = this.getUser();
    if (!account) throw new Error('No account');

    const API_SCOPE = `api://${AUTH_CLIENTID}/access_as_user`;

    try {

      const response = await this.msal.acquireTokenSilent({
        scopes: [API_SCOPE],
        account,
      });
      return response.accessToken;
    } catch (e) {
      if (e instanceof InteractionRequiredAuthError) {
        await this.msal.loginRedirect({ scopes: [API_SCOPE] });
      }
      throw e;
    }
  }

  logout() {
    this.msal.logoutRedirect();
  }
}
